export const config = {
  next_public_base_api: process.env.NEXT_PUBLIC_BASE_API,
  next_public_imgbb_api_url: process.env.NEXT_PUBLIC_IMGBB_API_URL,
  next_public_recaptcha_client_key:
    process.env.NEXT_PUBLIC_RECAPTCHA_CLIENT_KEY,
  next_public_recaptcha_server_key:
    process.env.NEXT_PUBLIC_RECAPTCHA_SERVER_KEY,
  service_id: process.env.NEXT_PUBLIC_SERVICE_ID,
  template_id: process.env.NEXT_PUBLIC_TEMPLATE_ID,
  public_key: process.env.NEXT_PUBLIC_PUBLIC_KEY,
  next_public_socket_api: process.env.NEXT_PUBLIC_SOCKET_API,
};
